<template>
    <div>
        <form class="form-horizontal auth-form my-4">
            <h5 class="text-danger text-center" v-if="errorMsg">{{ errorMsg }}</h5>
            <div class="form-group">
                <label for="code">{{titles.recoveryCode}}</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="fas  fa-sync-alt icon-sm"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.code.$error || wrongCode }"
                            :placeholder=titles.enterRecoveryCode
                            class="form-control"
                            id="code"
                            name="code"
                            type="text"
                            v-model="$v.code.$model"
                    />
                    <div class="invalid-feedback" v-if="!$v.code.required">
                        {{titles.fieldIsRequired}}
                    </div>
                    <div
                            class="invalid-feedback"
                            v-if="!$v.code.minLength || !$v.code.maxLength"
                    >
                        {{titles.errorLengthCode(10)}}
                    </div>
                    <div class="invalid-feedback" v-if="wrongCode">
                        {{titles.codeWrong}}
                    </div>
                </div>
            </div>
            <!--end form-group-->
            <div class="form-group mb-0 row">
                <div class="col-12 mt-2">
                    <button
                            :disabled="isLoading || $v.code.$model.length == 0"
                            class="btn btn-standard-gradient btn-round btn-block waves-effect waves-light"
                            type="button"
                            v-on:click="submit"
                    >
                        <b-spinner small v-if="isLoading"></b-spinner>
                        {{titles.next}} <i class="fas fa-sign-in-alt ml-1"></i>
                    </button>
                </div>
                <!--end col-->
            </div>
        </form>

        <div class="mx-3 mt-3 mb-0 text-center text-muted">
            <p class="mb-0">
                {{titles.rememberYourPassword}}
                <router-link class="text-primary ml-2" to="/auth/login"
                >{{titles.signInHere}}
                </router-link
                >
            </p>
        </div>
    </div>
</template>

<script>
    import {
        maxLength,
        minLength,
        required
    } from 'vuelidate/lib/validators';
    import {titles} from '../../../utils/general/titles.js';
    import {recoveryCodeCheck} from '../../shared/services/user.service';

    export default {
        name: 'codeForm',
        data() {
            return {
                titles,
                code: '',
                wrongCode: false,
                isLoading: false,
                errorMsg: ''
            };
        },
        validations: {
            code: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(10)
            }
        },
        methods: {
            submit() {
                this.isLoading = true;
                this.wrongCode = false;
                this.errorMsg = null;
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                recoveryCodeCheck(this.code).then(
                    () => {
                        this.$emit('next', this.code);
                        this.isLoading = false;
                    },
                    error => {
                        if (error.response.status) {
                            this.wrongCode = true;
                        } else {
                            this.errorMsg = 'An unknown error occurred. Try again later.';
                        }
                        this.isLoading = false;
                    }
                );
            }
        }
    };
</script>

<style scoped></style>
